/**
 * @description
 * Objeto dbindices
 */

import { Dbmodels } from "./dbmodels.model";

export class Dbindices {
    public id:number = null;
    public code:string = "";
    public dbmodelId: Dbmodels = new Dbmodels();
    public description:string;
    public ispk:boolean = false;
    public isunique:boolean = false;
  
    constructor() {}
  
}